import { render, staticRenderFns } from "./follow-artist.vue?vue&type=template&id=29b84f83"
import script from "./follow-artist.vue?vue&type=script&lang=js"
export * from "./follow-artist.vue?vue&type=script&lang=js"
import style0 from "./follow-artist.vue?vue&type=style&index=0&id=29b84f83&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b84f83')) {
      api.createRecord('29b84f83', component.options)
    } else {
      api.reload('29b84f83', component.options)
    }
    module.hot.accept("./follow-artist.vue?vue&type=template&id=29b84f83", function () {
      api.rerender('29b84f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/follow-artist.vue"
export default component.exports